import { CREATE_STORE, EDIT_STORE, EXPORT_STORES, LIST_STORE, UPLOAD_STORE_IMAGE, VIEW_STORE } from "./types";


export const createStoreAction = (data, onSuccess, onError) => {
    return {
        type: CREATE_STORE,
        data,
        onSuccess,
        onError,
    };
};

export const editStoreAction = (data, onSuccess, onError) => {
    return {
        type: EDIT_STORE,
        data,
        onSuccess,
        onError,
    };
};

export const listStoreAction = (data, onSuccess, onError) => {
    return {
        type: LIST_STORE,
        data,
        onSuccess,
        onError,
    };
};

export const viewStoreAction = (data, onSuccess, onError) => {
    return {
        type: VIEW_STORE,
        data,
        onSuccess,
        onError,
    };
};


export const uploadStoreImageAction = (file, onSuccess, onError) => {
    return {
        type: UPLOAD_STORE_IMAGE,
        file,
        onSuccess,
        onError,
    };
};

export const exportStoreAction = (data, onSuccess, onError) => {
    return {
        type: EXPORT_STORES,
        data,
        onSuccess,
        onError,
    };
};